import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { REEL_URL } from "@/data/content";

export const ReelModal = ({ open, onClose }) => {
  const { t } = useLang();
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="reel-modal"
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[200] bg-ink/90 backdrop-blur-md flex items-center justify-center p-4 md:p-10"
        >
          <button
            data-testid="reel-close"
            onClick={onClose}
            className="absolute top-5 right-5 h-11 w-11 rounded-full bg-white/10 hover:bg-brand hover:text-ink text-white flex items-center justify-center transition-colors duration-300"
          >
            <X size={24} />
          </button>
          <motion.div
            initial={{ scale: 0.92, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.92, y: 20 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-5xl"
          >
            <p className="font-bold text-brand uppercase tracking-[0.2em] text-sm mb-3">{t.reelTitle}</p>
            <div className="rounded-2xl overflow-hidden bg-black shadow-2xl">
              <video data-testid="reel-video" src={REEL_URL} controls autoPlay playsInline className="w-full h-auto max-h-[80vh]" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
